export { sweetpassHomeContentfulDataFixture } from './sweetpassHomeContentfulDataFixture';
export * from './useSweetpassHomeContentfulData';
